<template>
<div>
    <router-link v-if="row.type == relatedMerchantType.GATEWAY"
                 :to="'/stakeholders/update/' + row.id"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
    >
	    <i class="fas fa-edit"></i>
    </router-link>
    <router-link v-else-if="row.type == relatedMerchantType.WALLET"
                 :to="'/stakeholders/update-wallet-type/' + row.id"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
    >
	    <i class="fas fa-edit"></i>
    </router-link>
    <router-link v-else-if="row.type == relatedMerchantType.PSP"
                 :to="'/stakeholders/update-psp-type/' + row.id"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
    >
	    <i class="fas fa-edit"></i>
    </router-link>
    <router-link v-else-if="row.type == relatedMerchantType.PF"
                 :to="'/stakeholders/update-pf-type/' + row.id"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
    >
        <i class="fas fa-edit"></i>
    </router-link>
    <router-link v-if="$can('manage-stakeholder', 'user')"
                 :to="{name: 'stakeholders_change_status', params: { hashid: row.id, stakeholder_type: row.type } }"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
    >
        <i class="fas fa-cog"></i>
    </router-link>
    <a v-show="row.type == relatedMerchantType.GATEWAY" @click="deleteRelatedMerchant(row)"
                 class="btn btn-sm btn-clean btn-icon btn-icon-sm"
    >
	    <i class="fas fa-trash"></i>
    </a>
</div>
</template>

<script>
import Vue from 'vue';
import { relatedMerchantType } from '@/constants/related_merchant_type';
import { stakeholdersService } from '@/common/api.service';
import {i18n} from "@/plugins/i18n";

export default Vue.extend({
    data() {
        return {
            relatedMerchantType: relatedMerchantType,
        };
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },

    methods: {
        deleteRelatedMerchant(row) {
            if (confirm(i18n.t('stakeholders.alerts.delete_stakeholder'))) {
                stakeholdersService.delete(row.id)
                    .then(({data}) => {
                        this.toastr.success(data.message)
                        this.datatable.reload();
                    }).catch(({response}) => {
                        this.toastr.error(response.data.message)
                })
            }
        }
    }
})
</script>
